import { sprinkles } from '@design-system/sprinkles.css';
import { Cta, CtaProps } from '../cta/cta';
import {
  ctaElement,
  ctaStretch,
  ctaWrapper,
  ctaWrapperColumn,
} from './modalCta.css';
import { clsx } from 'clsx';

export type ModalCtaProps = {
  primaryCta?: CtaProps;
  secondaryCta?: CtaProps;
  columnCta?: boolean;
  reverseCta?: boolean;
  stretchCta?: boolean;
  testId?: string;
};

export const ModalCta = (p: ModalCtaProps) => {
  if (!p.primaryCta && !p.secondaryCta) {
    return null;
  }
  const columnsCount = p.secondaryCta ? 2 : 1;

  return (
    <div
      className={clsx(
        ctaWrapper,
        p?.columnCta && ctaWrapperColumn,
        p?.stretchCta && ctaStretch,
        p?.reverseCta &&
          sprinkles({
            flexDirection: p?.columnCta ? 'column-reverse' : 'row-reverse',
          }),
      )}
      style={{
        gridTemplateColumns: `repeat(${columnsCount}, 1fr)`,
      }}
      data-testid={p.testId && `btnWrapper-${p.testId}`}
    >
      {p.secondaryCta && (
        <Cta
          {...p.secondaryCta}
          className={clsx(ctaElement)}
          secondary
          testId={p.testId && `secondary-${p.testId}`}
        />
      )}
      {p.primaryCta && (
        <Cta
          {...p.primaryCta}
          className={clsx(ctaElement)}
          testId={p.testId && `primary-${p.testId}`}
        />
      )}
    </div>
  );
};
